exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Color schema */\n/* Hidden class */\n.uu5-common-hidden {\n  display: none !important;\n}\n/* Disabled class */\n.uu5-common-disabled {\n  position: relative !important;\n  cursor: not-allowed !important;\n}\n/* Disabled cover class wrapper - must set position relative on wrap element */\n.uu5-common-disabled-cover-wrapper {\n  position: relative;\n  display: inline-block;\n}\n/* Disabled cover class */\n.uu5-common-disabled-cover,\n.uu5-common-disabled-cover-transparent {\n  position: absolute;\n  cursor: not-allowed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: 0.7;\n  z-index: 90;\n}\n.uu5-common-disabled-cover {\n  background-color: lightgrey;\n}\n.uu5-common-disabled-cover-transparent {\n  background-color: transparent;\n}\n/* START - remove bootstrap focus on buttons */\n.btn:focus {\n  outline: none;\n}\n/* END - remove bootstrap focus on buttons */\n/* standard color classes */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./common/color-schema.less
// module id = 287
// module chunks = 0